// Point d'entrée centralisé pour tous les services API
import auth from './auth';
import clients from './clients';
import appointments from './appointments';
import staff from './staff';
import services from './services';
import calendar from './calendar';
import transactions from './transactions';
import analytics from './analytics';
import settings from './settings';
import subscription from './subscription';
import promotions from './promotions';
import fidelite from './fidelite';
import prospects from './prospects';

export default {
  auth,
  clients,
  appointments,
  staff,
  services,
  calendar,
  transactions,
  analytics,
  settings,
  subscription,
  promotions,
  fidelite,
  prospects,
};
